module.exports = __webpack_public_path__ + "img/award.122b0de1.png";